import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { withTranslation } from "react-i18next";
import { buildingNonComplianceBarChartColor } from "common/constant";

const NonComplianceCorrectiveActionBarChart = ({
  t,
  nonComplianceBuildingData,
}) => {
  const initialOption = {
    chart: {
      height: 350,
      type: "bar",
      stacked: true,
    },
    dataLabels: {
      enabled: true,
    },
    xaxis: {
      categories: [],
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    plotOptions: {
      bar: {
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "last",
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    legend: {
      onItemHover: {
        highlightDataSeries: false,
      },
    },
    colors: buildingNonComplianceBarChartColor,
  };

  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState(initialOption);

  useEffect(() => {
    const buildingData = {};
    nonComplianceBuildingData.forEach((record) => {
      const buildingRecord = record.buildingRecords[0];
      const buildingName = buildingRecord.buildingName;
      const { completed, pending } = buildingRecord.buildingDetails[0];

      if (!buildingData[buildingName]) {
        buildingData[buildingName] = { completed: 0, pending: 0 };
      }

      buildingData[buildingName].completed += completed;
      buildingData[buildingName].pending += pending;
    });

    const categories = Object.keys(buildingData);

    const completedCounts = categories.map(
      (category) => buildingData[category].completed
    );
    const pendingCounts = categories.map(
      (category) => buildingData[category].pending
    );

    setSeries([
      { name: "Completed", data: completedCounts },
      { name: "Pending", data: pendingCounts },
    ]);

    setOptions((prev) => ({
      ...prev,
      xaxis: { ...prev.xaxis, categories },
    }));
  }, [nonComplianceBuildingData]);

  return (
    <Card className="p-0">
      <CardHeader
        title={
          <Grid container>
            <Grid item xs={8}>
              <Typography variant="subtitle1" fontWeight={700}>
                {t("Building Non-Compliance Status")}
              </Typography>
            </Grid>
          </Grid>
        }
        className="border-bottom"
      />
      <CardContent>
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={450}
        />
      </CardContent>
    </Card>
  );
};

NonComplianceCorrectiveActionBarChart.propTypes = {
  nonComplianceBuildingData: PropTypes.array,
  t: PropTypes.func,
};

export default withTranslation()(NonComplianceCorrectiveActionBarChart);
